module.exports = __webpack_public_path__ + "static/media/vertex-6502x-m.b6024746.jpg";